<template>
  <layout-default-filters @open="$_OnOpen" @apply="$_applyQueryString" :hideButton="filtroInicial">
    <template #superior>
      <div class='div-geral'>
        
        <div class='primeiro-filtro'>
          <v-form ref="form">
            <div style="height: 50px;"></div>
          </v-form>
        </div>

        <div class='segundo-filtro'>
          
          <div v-if="filtroAtivo === null">
            <core-text-field
              clearable class='txt-filter'
              @focus="ativarFiltro('grupo')"
              v-model="termoBusca"
              label='Grupo'
              min="0"
              @keydown="bloquearCaracteresInvalidos"
              @input="garantirPositivo"
              :type='inputType'
            />
          </div>

          <div v-if="filtroAtivo === 'grupo'">
            <div class='radios' :class="{ 'visible': filtroAtivo === 'grupo' }">
              <v-radio-group v-model="radioGrupo" hide-details class="mt-0">
                <v-row dense>
                  <v-col cols="6" class="py-0">
                    <v-radio :label="radioLabelGrupo[0]" :value="1"></v-radio> </v-col>
                  <v-col cols="6" class="py-0 pb-3">
                    <v-radio :label="radioLabelGrupo[1]" :value="2"></v-radio> </v-col>
                </v-row>
              </v-radio-group>
            </div>

            <core-text-field
              clearable class='txt-filter'
              @focus="ativarFiltro('grupo')"
              @keyup.enter="$_load(1)" 
              v-model="termoBusca"
              min="0"
              @keydown="bloquearCaracteresInvalidos"
              @input="garantirPositivo"
              label='Pesquisar Grupo...'
              :type='inputType'
            />
            
            <div class='btns-wrap' :class="{ 'visible': filtroAtivo === 'grupo' }">
              <v-btn rounded color='primary' class='btns' @click='$_load(0)'>
                <v-icon>mdi-arrow-left-thick</v-icon>
              </v-btn>
              <v-btn rounded color='primary' class='btns reducesize' @click='$_load(1)'>
                <v-icon>mdi-arrow-left-thick</v-icon><v-icon>mdi-arrow-right-thick</v-icon>
              </v-btn>
              <v-btn rounded color='primary' class='btns-mini' @click='$_load(2)'>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>

            <template v-if="filtroAtivo === 'grupo'">
              <v-divider></v-divider>
              <div class="mx-auto cardlist" max-width="500">
                
                <div v-if="loading" class="text-center pa-4">
                  <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
                </div>

                <v-list two-line class='scroll' v-else>
                  <v-list-item-group active-class="green--text" multiple>
                    <template v-for="(item, index) in itemsGrupo">
                      <v-list-item :key="item.idgrupo + '-' + index">
                        <v-card class='cardpessoa' @click="$_onClickCard(item.descricao, item.idgrupo)">
                          <div style="height: 100%; display: flex; align-items: center; padding-left: 16px;">
                            <span class="font-weight-medium">{{ item.idgrupo }} - {{ item.descricao }}</span>
                          </div>
                        </v-card>
                      </v-list-item>
                      <v-divider v-if="index < itemsGrupo.length - 1" :key="index"></v-divider>
                    </template>
                    
                    <v-list-item v-if="itemsGrupo.length === 0 && termoBusca">
                      <v-list-item-content>
                        <v-list-item-title class="text-center grey--text">Nenhum grupo encontrado.</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </div>
              <v-divider></v-divider>
            </template>
          </div>
          
        </div>
      </div>
    </template>
  </layout-default-filters>
</template>

<script>
import { mapMutations } from 'vuex';
import db from '@/plugins/dexie';
import { getQueryValue, setQueryValue } from '@/services/query-string';
import LayoutDefaultFilters from '@/layouts/default/NewFilters.vue';
import CoreTextField from '@/components/core/text-field/Index.vue';
import errorHandler from '@/utils/error-handler';
import storage from '@/services/storage';
const STORAGE_KEY_TEXTO_GRUPO = 'filtro_grupo_texto';

export default {
  name: 'ViewPesquisaGrupoFilters',

  components: {
    LayoutDefaultFilters,
    CoreTextField,
  },

  data() {
    return {
      filtroAtivo: null,
      filtroInicial: false,
      inputType: 'text',
      loading: false,

      itemsGrupo: [],
      radioGrupo: 1, // 1 = Descrição, 2 = Código
      radioLabelGrupo: ['Descrição', 'Código'],
      termoBusca: null,

      filters: {
        idgrupo: null,
      },
    };
  },

  methods: {
    ...mapMutations({
      $_setRefresh: 'filter/refresh',
    }),

    garantirPositivo() {
      if (this.termoBusca && this.termoBusca < 0) {
        this.termoBusca = Math.abs(this.termoBusca).toString();
      }
    },

    bloquearCaracteresInvalidos(e) {
      if (['-', '+'].includes(e.key)) {
        e.preventDefault();
      }
    },

    ativarFiltro(nomeFiltro) {
      this.filtroAtivo = nomeFiltro;
      if (!this.filtroInicial) {
        this.subirForm(true);
      }
      
      this.inputType = 'text';

      if (this.termoBusca) {
        this.$_load(1);
      }
    },

    async $_load(parametroLoad) {
      if (parametroLoad === 2) {
          this.termoBusca = null;
          this.filters.idgrupo = null;
          storage.setItem(STORAGE_KEY_TEXTO_GRUPO, '');
          this.$_applyQueryString();
          
          this.itemsGrupo = [];
          this.subirForm(0);
          this.loading = false;
          return;
      }

      this.loading = true;
      try {
        if (this.filtroAtivo === 'grupo') {
          const resultadosLocais = await this.buscarNoDexie(parametroLoad);
          
          if (resultadosLocais.length > 0) {
            this.itemsGrupo = this.removerDuplicados(resultadosLocais);
          } else {
            this.itemsGrupo = [];
          }
        }
      } catch (err) {
        errorHandler.call(this, err);
      } finally {
        this.loading = false;
      }
    },

    removerDuplicados(lista) {
      const unicos = [];
      const idsVistos = new Set();
      lista.forEach(item => {
        if (!idsVistos.has(item.idgrupo)) {
          idsVistos.add(item.idgrupo);
          unicos.push(item);
        }
      });
      return unicos;
    },

    async buscarNoDexie(tipoBusca) {
      if (!this.termoBusca) return [];
      const texto = this.termoBusca.trim();
      if (texto === '') return [];

      const textoLower = texto.toLowerCase();

      try {
        let collection = db.grupo.toCollection();

        return await collection.filter(grupo => {
          if (this.radioGrupo === 1) { // Filtro por Descrição
              if (!grupo.descricao) return false;
              
              if (tipoBusca === 0) {
                  return grupo.descricao.toLowerCase().startsWith(textoLower);
              } else {
                  return grupo.descricao.toLowerCase().includes(textoLower);
              }
          }
          if (this.radioGrupo === 2) { // Filtro por Código (ID)
              const codInterno = grupo.idgrupo ? grupo.idgrupo.toString().toLowerCase() : '';
              
              if (tipoBusca === 0) {
                return codInterno.startsWith(textoLower);
              } else {
                return codInterno.includes(textoLower);
              }
          }
          return false;
        })
        .limit(50) 
        .toArray();

      } catch (e) {
        console.warn("Erro na query do Dexie:", e);
        return [];
      }
    },

    $_applyQueryString() {
      // Limpa as variáveis da URL
      setQueryValue('idgrupo', null);
      setQueryValue('busca_grupo', null); // Usando nome exclusivo para não conflitar
      
      // Seta o novo filtro selecionado
      if (this.filters.idgrupo) {
          setQueryValue('idgrupo', this.filters.idgrupo);
      } 
      else if (this.termoBusca) {
          setQueryValue('busca_grupo', this.termoBusca);
      }
      
      this.$_setRefresh('S');
    },

    $_OnOpen() {
      this.subirForm(false);
    },

    subirForm(bool) {
      if (bool) {
        if (this.filtroInicial) { return; }
        document.querySelector('.primeiro-filtro').style.opacity = '0';
        document.querySelector('.primeiro-filtro').style.zIndex = '-1';
        
        const topValue = this.$_isMobile ? '-50px' : '-50px'; 
        document.querySelector('.segundo-filtro').style.top = topValue;
        
        this.filtroInicial = true;
      } else {
        if (!this.filtroInicial) { return; }
        document.querySelector('.primeiro-filtro').style.opacity = '1';
        document.querySelector('.primeiro-filtro').style.zIndex = '2';
        document.querySelector('.segundo-filtro').style.top = '0';
        
        this.filtroInicial = false;
        this.filtroAtivo = null;
      }
    },

    $_onClickCard(nome, idgrupo) {
      if (this.filtroInicial) {
        if (this.filtroAtivo === 'grupo') {
          this.termoBusca = `${nome}`; 
          storage.setItem(STORAGE_KEY_TEXTO_GRUPO, this.termoBusca);
          
          this.filters.idgrupo = idgrupo;
        }
        
        this.$_applyQueryString();
        this.subirForm(0);
      }
    },
  },

  watch: {
    radioGrupo() {
      this.itemsGrupo = [];
      if (this.termoBusca) this.$_load(1);
    },

    $route: {
      deep: true,
      immediate: true,
      async handler() {
        const id = getQueryValue('idgrupo', null);
        const busca = getQueryValue('busca_grupo', null);

        if (id) { 
            const gru = await db.grupo.where({ idgrupo: Number(id) }).first();
            this.termoBusca = gru ? gru.descricao : `Grupo Cód: ${id}`;
            this.filters.idgrupo = id;
        }
        else if (busca) { 
            this.termoBusca = busca;
            this.filters.idgrupo = null;
        }
        else {
            const valorSalvo = await storage.getItem(STORAGE_KEY_TEXTO_GRUPO);
            this.termoBusca = (typeof valorSalvo === 'string') ? valorSalvo : null;
            this.filters.idgrupo = null;
        }
      },
    },
  },
};
</script>

<style scoped>
  /* Os estilos continuam os mesmos */
  .div-geral { height: 0%; }
  .btns-wrap { display: flex; justify-content: space-around; height: 50px; transition: opacity 0.3s; opacity: 0; }
  .btns { width: 33%; transition: opacity 0.3s; }
  .btns.reducesize { width: 33%; }
  .btns-mini { width: 10%; transition: opacity 0.3s; }
  .primeiro-filtro { transition: opacity 0.3s; position: relative; opacity: 1; z-index: 1; }
  .segundo-filtro { transition: top 0.4s; position: relative; z-index: 1; height: 0px; }
  .radios { transition: opacity 0.3s; opacity: 0; height: auto; }
  .radios.visible, .btns-wrap.visible { opacity: 1; }
  .mx-auto.cardlist { transition: opacity 0.3s, top 0.4s; height: 50vh; overflow-y: scroll; background-color: rgb(245, 245, 245); }
  .cardpessoa { height: 60px; width: 100%; margin-top: 5px; cursor: pointer; }
  .txt-filter { height: 50px; }
</style>